import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39479607"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "debug" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "home" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"intro\" data-v-39479607><div class=\"text\" data-v-39479607><div data-v-39479607><h1 class=\"title\" data-v-39479607>Explore. Digitalize. Succeed.</h1><p class=\"subtitle\" data-v-39479607>Façonnez votre avenir numérique avec notre savoir-faire en développement et hébergement de solutions digitales, taillées sur mesure pour votre succès.</p></div></div></div><a id=\"ctoaas\" data-v-39479607></a>", 2)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "blur" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "CTO as a Service"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Maximisez votre potentiel technologique avec notre service CTO as a Service. L'expertise d'un CTO sans les contraintes.")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"block text\" data-v-39479607><p data-v-39479607>Nous vous proposons notre compétence de Chief Technology Officer (CTO) expérimenté pour bénéficier de notre expertise stratégique et technique, sans la contrainte d&#39;une embauche à temps plein. Cela permet d&#39;accéder à une direction technologique de haut niveau de manière flexible et rentable, particulièrement utile pendant la phase de démarrage de votre projet.</p></div><div class=\"block text\" data-v-39479607><div class=\"columns\" data-v-39479607><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Gestion de projet</div><p data-v-39479607>Nous pouvons vous aider à organiser et superviser la gestion de projets technologiques, du développement à la mise en œuvre. Nous vous aidons à cadrer votre projet de transformation digital selon vos exigences métiers et budgétaires, à coordonner les équipes internes et externes, à assurer le respect des délais et à gérer les risques.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Architecture technique</div><p data-v-39479607>Nous pouvons travaille ensemble à l&#39;élaboration d&#39;une architecture technique solide et scalable pour les solutions logicielles ou les infrastructures de l&#39;entreprise. Nous veillons à ce que votre environnement technique réponde aux besoins présents et futurs de votre entreprise, de vos clients et de vos collaborateurs.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Recrutement de talents</div><p data-v-39479607>Vous souhaitez engager un Développeur ou un Data Analyst/Scientist ? Nous pouvons vous apporter notre expertise dans le recrutement et la gestion des talents technologiques. Nous vous aidons à identifier les compétences requises, participons aux processus d&#39;embauche et proposons des stratégies de développement des compétences pour vos équipes techniques.</p></div></div></div>", 2)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "develop" }, null, -1))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "blur" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Développement"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Transformez votre idée en une application épique ! Notre équipe crée des apps sur mesure et prêtes à conquérir le monde numérique.")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"block text\" data-v-39479607><div class=\"columns\" data-v-39479607><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Offrez une expérience exclusive à vos utilisateurs</div><p data-v-39479607>Imaginez une application avec une interface utilisateur élégante et intuitive, des fonctionnalités avancées et une performance inégalée : nous vous aiderons à la concrétiser.</p><p data-v-39479607>Grâce à notre expertise, nous vous aiderons à amener vos utilisateurs à se sentir privilégiés et à rester fidèles à votre marque.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>La performance au service de vos utilisateurs</div><p data-v-39479607>Rien de plus frustrant qu&#39;une interface qui ne semble ne pas charger les données, qui trainent à traiter une demande ou l&#39;absence d&#39;information sur les erreurs communes.</p><p data-v-39479607>Dans notre approche User First, nous vous apportons une vision qui se préocupe d&#39;abord de vos utilisateurs finaux, car ce sont eux qui permettent à votre activité de croître.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Protégez la confidentialité de vos utilisateurs</div><p data-v-39479607>Au-delà d&#39;une simple mise en conformité, la sécurisation des données utilisateurs est avant tout une image forte de confiance dans votre marque.</p><p data-v-39479607>En nous confiant votre besoin, nous pouvons mettre en place des niveaux de sécurité et de protection qui rassurent vos clients.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Anticipez la croissance de votre application</div><p data-v-39479607>Parce que développer une application métier est un engagement financier fort, nous designons nos solutions pour qu&#39;elles puissent croître avec votre activité.</p><p data-v-39479607>Nos solutions technologiques sont flexibles et évolutives et peuvent donc s&#39;adapter aux besoins changeants de votre entreprise et aux attentes de vos utilisateurs sans devoir à chaque fois repartir de zéro.</p></div><div class=\"column\" data-v-39479607><div class=\"title\" data-v-39479607>Ne restez plus seuls après le lancement</div><p data-v-39479607>Bénéficiez d&#39;un soutien continu et d&#39;une maintenance de qualité : nous sommes là pour vous accompagner, même après le lancement de votre application.</p><p data-v-39479607>Notre équipe reste à votre disposition pour fournir un support technique et assurer une maintenance continue, afin que votre application fonctionne de manière optimale.<sup class=\"footnote\" data-v-39479607><a href=\"#footnote-1\" data-v-39479607>1</a></sup></p></div></div></div><div class=\"block text\" data-v-39479607><div class=\"scroll\" data-v-39479607><div data-v-39479607> Prêt à nous faire confiance ? Déroulez la page pour voir le cheminement d&#39;un contrat avec notre équipe. 😃 </div><div class=\"icon\" data-v-39479607><div class=\"mouse\" data-v-39479607><div class=\"wheel\" data-v-39479607></div></div></div></div></div>", 2)
const _hoisted_19 = { class: "block text parallax" }
const _hoisted_20 = { class: "galaxy" }
const _hoisted_21 = { class: "step" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "overlay",
  style: {"background-image":"url('https://images.unsplash.com/photo-1569229761589-8838faca0b91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3805&q=30')"}
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id" }, "1", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Rédaction du Cahier des Charges", -1))
const _hoisted_26 = { class: "technology" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Prérequis", -1))
const _hoisted_28 = { class: "list" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { class: "item" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Vous êtes prêt à nous confier votre projet ? Parfait ! Mais avant de sortir les premières lignes de code, il faut que nous nous comprenions."),
  /*#__PURE__*/_createElementVNode("p", null, "Cette compréhension passe par un Cahier des Charges. C'est l'élément essentiel dont vous avez besoin, et nous aussi."),
  /*#__PURE__*/_createElementVNode("p", null, "En mettant par écrit vos idées, vos besoins et vos attentes, vous assurez une compréhension mutuelle sans risquer de se perdre en cours de route. C'est le secret pour éviter les malentendus et les déceptions, et pour garantir un résultat final le plus idéal possible. De plus, il nous permettra de vous livrer une estimation du coût de votre future application la plus précise possible."),
  /*#__PURE__*/_createElementVNode("p", null, "Alors, êtes-vous prêt à donner vie à votre projet avec un cahier des charges qui fera sensation ?"),
  /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "💡 Astuce !"),
    /*#__PURE__*/_createTextVNode(" Même si vous pensez détenir un Cahier des Charges, c'est le plus souvent une Expression de Besoins qui nécessite d'être challengée pour être en phase avec vos contraintes. C'est pourquoi nous pouvons vous aider à le rédiger.")
  ])
], -1))
const _hoisted_33 = { class: "step" }
const _hoisted_34 = { class: "content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id" }, "2", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Planning", -1))
const _hoisted_37 = { class: "technology" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Prérequis", -1))
const _hoisted_39 = { class: "list" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-39479607><p data-v-39479607>Nous avons travaillé ensemble à la rédaction du Cahier des Charges ? Bien ! Maintenant, pour vous rassurer et vous donner de la vision, nous allons mettre en place un Planning.<sup class=\"footnote\" data-v-39479607><a href=\"#footnote-2\" data-v-39479607>2</a></sup></p><p data-v-39479607>Une planification rigoureuse permet de suivre le déroulement du projet, de respecter les échéances et de prendre des mesures correctives si nécessaire.</p><p data-v-39479607>Mais ça ne veut pas dire que nous ne pouvons pas montrer un peu de souplesse ou que nous allons nous enfermer dans notre cave pendant un an, le temps de développer votre application. Nous ponctuons les temps de développement avec des temps de synchronisation avec votre coordinateur(rice) et, selon la complexité du projet, avec des livraisons sur un environnement de test qui vous est dédié.<sup class=\"footnote\" data-v-39479607><a href=\"#footnote-3\" data-v-39479607>3</a></sup></p><p class=\"tips\" data-v-39479607><strong data-v-39479607>💡 Astuce !</strong> Pour votre image de marque, ne communiquez jamais de dates de sortie à vos clients et prospects avant d&#39;être sûr de pouvoir fournir le service.</p></div>", 1)
const _hoisted_43 = { class: "step" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "overlay",
  style: {"background-image":"url('https://images.unsplash.com/photo-1576153192396-180ecef2a715?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3774&q=30')"}
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id" }, "3", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Maquettes et Expérience Utilisateur (UX)", -1))
const _hoisted_48 = { class: "technology" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Technologies", -1))
const _hoisted_50 = { class: "list" }
const _hoisted_51 = { class: "item" }
const _hoisted_52 = { class: "item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Le maquettage en design d'applications est une étape cruciale dans le processus de développement. En créant des maquettes visuelles, nous donnons vie à vos idées et vous permettons de vous projeter et tester l'ergonomie et l'expérience utilisateur avant même de commencer à poser les premières lignes de code."),
  /*#__PURE__*/_createElementVNode("p", null, "Grâce à cette méthode, nous évitons les modifications qui peuvent s'avérer coûteuses à un stade avancé de votre projet, car les maquettes offrent une vision claire de l'apparence et du fonctionnement de l'application."),
  /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "💡 Astuce !"),
    /*#__PURE__*/_createTextVNode(" Faire une maquette n'est pas un gage de résultat 100% identique au bout du projet (contraintes techniques ou structuruelles qui empêche parfois un développement à l'identique), mais ça donne les grandes lignes aux acteurs du projet.")
  ])
], -1))
const _hoisted_54 = { class: "step" }
const _hoisted_55 = { class: "content" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "overlay",
  style: {"background-image":"url('https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3869&q=30')"}
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id" }, "4", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Développement", -1))
const _hoisted_59 = { class: "technology" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Technologies", -1))
const _hoisted_61 = { class: "list" }
const _hoisted_62 = { class: "item" }
const _hoisted_63 = { class: "item" }
const _hoisted_64 = { class: "item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "L'étape de développement dans un projet de développement d'application est essentielle pour concrétiser vos idées et transformer vos besoins en une réalité fonctionnelle. C'est à ce stade que nos développeurs travaillent pour transformer les maquettes en une application complète et opérationnelle. Grâce à notre expertise technique, nous prenons en charge la programmation, la création des fonctionnalités et l'intégration des différents composants pour créer une application robuste et performante."),
  /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "💡 Astuce !"),
    /*#__PURE__*/_createTextVNode(" Nous travaillons avec des technologies qui permettent de faire évoluer dans le futur vos applications, notamment en scalabilité horizontale.")
  ])
], -1))
const _hoisted_66 = { class: "step" }
const _hoisted_67 = { class: "content" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "overlay",
  style: {"background-image":"url('https://images.unsplash.com/photo-1494412651409-8963ce7935a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3763&q=30')"}
}, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id" }, "5", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Livraison", -1))
const _hoisted_71 = { class: "technology" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Technologies", -1))
const _hoisted_73 = { class: "list" }
const _hoisted_74 = { class: "item" }
const _hoisted_75 = { class: "item" }
const _hoisted_76 = { class: "item" }
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-39479607><p data-v-39479607>La phase de livraison dans un projet de développement d&#39;application est une étape excitante où vous voyez enfin votre idée se concrétiser sous la forme d&#39;une application prête à être utilisée. Après des semaines ou des mois de collaboration étroite avec notre équipe de développement, votre application est maintenant prête à être déployée sur les plateformes appropriées, que ce soit sur le web, sur les appareils mobiles ou sur d&#39;autres supports.</p><p class=\"tips\" data-v-39479607><strong data-v-39479607>💡 Astuce !</strong> Nous travaillons de manière à vous livrer régulièrement une mise à jour, pour que vous puissiez valider la direction que prends le projet.</p><p data-v-39479607>Nous livrons toujours les sources de votre application sur un répertoire Git, libre à vous de souscrire pour une option en Déploiement Continue (avec des <em data-v-39479607>workflows</em> automatisés pour la publication en toute autonomie de votre application et de ses versions à venir)<sup class=\"footnote\" data-v-39479607><a href=\"#footnote-4\" data-v-39479607>4</a></sup>, de travailler avec notre partenaire Liift, expert en transformation Cloud, ou de choisir vous-même un prestataire de votre choix.<sup class=\"footnote\" data-v-39479607><a href=\"#footnote-5\" data-v-39479607>5</a></sup></p></div>", 1)
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "hosting" }, null, -1))
const _hoisted_79 = { class: "content" }
const _hoisted_80 = { class: "blur" }
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrapper" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Hosting"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Levée de rideau pour votre produit innovant ! Hébergement à prix réduit pour un lancement réussi et une expérience utilisateur sans limites.")
  ])
], -1))
const _hoisted_83 = { class: "block cards" }
const _hoisted_84 = { class: "grid" }
const _hoisted_85 = { class: "card" }
const _hoisted_86 = { class: "title" }
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-39479607>Nous configurons votre environnement</div><div class=\"pricing\" data-v-39479607><div data-v-39479607><div class=\"label\" data-v-39479607>Prix mensuel</div><div class=\"value\" data-v-39479607>Selon vos besoins</div></div><div data-v-39479607><div class=\"label\" data-v-39479607>Frais d&#39;installation</div><div class=\"value\" data-v-39479607>À partir de 260,00 €</div></div></div><div class=\"conditions\" data-v-39479607><div class=\"subtitle\" data-v-39479607>Conditions</div><ul data-v-39479607><li data-v-39479607>Uniquement pour les développements que nous réalisons</li><li data-v-39479607>Vous êtes propriétaire du projet</li><li data-v-39479607>Limité à GCP, AWS et OVHcloud</li><li data-v-39479607>Support : limité pendant les premiers mois d&#39;exploitation</li></ul></div>", 3)
const _hoisted_90 = { class: "card" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "soon" }, "Bientôt disponible", -1))
const _hoisted_92 = { class: "title" }
const _hoisted_93 = /*#__PURE__*/_createStaticVNode("<div class=\"description\" data-v-39479607>Nous gérons l&#39;exploitation de votre solution sur notre Cloud</div><div class=\"pricing\" data-v-39479607><div data-v-39479607><div class=\"label\" data-v-39479607>Prix mensuel</div><div class=\"value\" data-v-39479607>Selon vos besoins</div></div><div data-v-39479607><div class=\"label\" data-v-39479607>Frais d&#39;installation</div><div class=\"value\" data-v-39479607>Offerts</div></div></div><div class=\"conditions\" data-v-39479607><div class=\"subtitle\" data-v-39479607>Conditions</div><ul data-v-39479607><li data-v-39479607>Support : <em data-v-39479607>Best Effort</em> sans limite de temps</li></ul></div>", 3)
const _hoisted_96 = { class: "block content faq" }
const _hoisted_97 = { class: "block text" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Questions fréquentes", -1))
const _hoisted_99 = { class: "columns" }
const _hoisted_100 = { class: "column" }
const _hoisted_101 = { class: "item" }
const _hoisted_102 = { class: "icon" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Proposez-vous du référencement naturel ? ", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, " Non, nous sommes Éditeur de Logiciels ; notre domaine d'expertise est le développement d'applications à forte valeur ajoutée, mais nous laissons à nos clients le soin de promouvoir comme ils le souhaitent leur application. ", -1))
const _hoisted_105 = { class: "item" }
const _hoisted_106 = { class: "icon" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Pouvez-vous connecter mon application avec ma banque ? ", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, " Oui, nous avons une expérience significative avec Stripe mais aussi des APIs bancaires. ", -1))
const _hoisted_109 = { class: "item" }
const _hoisted_110 = { class: "icon" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Je souhaite que mon projet reste confidentiel ", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, " Nous comprenons le besoin de confidentialité, notamment en phase de conception d'un projet ; si besoin, nous pouvons signer un accord de non-divulgation (ou NDA). ", -1))
const _hoisted_113 = { class: "item" }
const _hoisted_114 = { class: "icon" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Pouvez-vous connecter mon application à Slack ou Discord ? ", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, " Oui, nous sommes habitués à travailler avec les APIs de toute nature : des envois transactionnels en e-mail ou en SMS, en passant par les APIs d'OCR (reconnaissance optique de caractères) jusqu'aux APIs de plateforme collaborative. ", -1))
const _hoisted_117 = { class: "column" }
const _hoisted_118 = { class: "item" }
const _hoisted_119 = { class: "icon" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Pouvez-vous reprendre un développement d'un autre éditeur ? ", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, " Nous pouvons bien entendu reprendre un développement qui a déjà été mené pour le faire évoluer. Nous prendrons le temps d'auditer le code auparavant pour nous assurer que nous pourrons vous fournir le niveau de qualité que nous souhaitons fournir à tous nos clients. ", -1))
const _hoisted_122 = { class: "item" }
const _hoisted_123 = { class: "icon" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question" }, " Êtes-vous conforme avec la RGPD ? ", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "answer" }, [
  /*#__PURE__*/_createTextVNode(" Tout au long du projet, nous sommes amené à vous conseiller sur l'utilisation ou le stockage des données personnelles. Si nous sommes amenés à travailler avec des données de votre entreprise, nous appliquerons le règlement : les données seront stockés et traités dans des datacenters européens, éventuellement sur nos postes (France), et toujours supprimée dès la fin de la mission."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nous savons que l'image de nos clients dépends non seulement des produits que nous développons mais également de la qualité du traitement des données de vos utilisateurs. ")
], -1))
const _hoisted_126 = /*#__PURE__*/_createStaticVNode("<div class=\"block content footnotes\" data-v-39479607><ol data-v-39479607><li data-v-39479607><a id=\"footnote-1\" data-v-39479607></a> Service inclus pour une période déterminée, indiquée au moment du devis, pouvant faire l&#39;objet d&#39;une prorogation par un Contrat de Support complémentaire. </li><li data-v-39479607><a id=\"footnote-2\" data-v-39479607></a> Donné à titre indicatif, ne pouvant faire l&#39;objet de pénalités. </li><li data-v-39479607><a id=\"footnote-3\" data-v-39479607></a> Mis à disposition à titre gratuit le temps du développement sans garantie de performance ni de disponibilité. </li><li data-v-39479607><a id=\"footnote-4\" data-v-39479607></a> Vous seuls prenez en charge les coûts liés à l&#39;exploitation du logiciel. </li><li data-v-39479607><a id=\"footnote-5\" data-v-39479607></a> Des frais complémentaires peuvent s&#39;appliquer pour les contraintes logicielles imposées par votre prestataire. </li></ol></div>", 1)

import HomeHeader from '@/components/home/HomeHeader.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { isMobile } from 'mobile-device-detect'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

let currentStep = null
let autoFocus = null
let lockScroll = null
let wheelDirection = null
let wheelInit = window.scrollY
let wheelDelta = 0
const imgSize = ref(isMobile ? 1512 : 600)

const moveCard = function($event: MouseEvent){
    let obj = ($event.target as HTMLElement)
    while (!obj.className.includes('animation')) obj = obj.offsetParent
    const blurObj = (obj.querySelector('.blur') as HTMLElement)
    if (blurObj) {
        const width = blurObj.offsetWidth
        const height = blurObj.offsetHeight
        const mousePx = ($event.pageX - blurObj.offsetLeft - width) / width
        const mousePy = ($event.pageY - (blurObj.offsetTop + blurObj.offsetParent.offsetTop) - height/2) / height
        const tX = mousePx * -20
        const tY = mousePy * -20
        blurObj.style.transform = `translateX(${tX}px) translateY(${tY}px) scale(1.02)`
    }
    return false
}

const outCard = function($event: MouseEvent){
    setTimeout(() => {
        let obj = ($event.target as HTMLElement)
        while (!obj.className.includes('animation')) obj = obj.offsetParent
        const blurObj = (obj.querySelector('.blur') as HTMLElement)
        if (blurObj) {
            blurObj.style.transform = 'translateX(0deg) translateY(0deg) scale(1.02)'
        }
    }, 500)
    return false
}

const manageScroll = function(){

    document.querySelectorAll('.blur').forEach((blurObj) => {
        const bounds = blurObj.getBoundingClientRect()
        const scrollTop = bounds.top - 60
        // blurObj.style.height = blurObj.offsetParent.querySelector('.content').offsetHeight
        blurObj.scrollTo({
            top: scrollTop,
            left: 0
        })
    })

    if (window.innerWidth <= 600) return false

    currentStep = null
    clearTimeout(autoFocus)
    autoFocus = setTimeout(() => {
        if (!lockScroll) {
            wheelDirection = window.scrollY > wheelInit ? 'upToDown' : 'downToUp'
            wheelDelta = window.scrollY - wheelInit
            wheelInit = window.scrollY
            let focusPosition = null
            const debug = document.querySelector('#debug')
            document.querySelectorAll('.parallax .step').forEach((objStep) => {
                const wHeight = window.innerHeight
                const margin = wHeight / 2
                const anchor = wHeight / 5
                const anchor2 = wHeight / 3
                const oTop = parseInt(objStep.getAttribute('data-originalPosition'), 10)
                const isInLine =  (oTop - margin) < window.scrollY && window.scrollY < (oTop + margin)
                debug.innerHTML = `${debug?.innerHTML}<br>${oTop}px / ${wheelDirection} : ${wheelDelta} / ${oTop - margin} < ${window.scrollY} < ${oTop + margin} ? ${isInLine} / ${lockScroll}`
                debug.innerHTML = `${debug?.innerHTML}<br>${wheelDelta} <> ${(wHeight / anchor)}`
                debug?.scrollTo({top: 100000000000})
                if (wheelDirection == 'upToDown' && isInLine && Math.abs(wheelDelta) > (wHeight / anchor)) {
                    focusPosition = oTop
                }
                else if (wheelDirection == 'downToUp' && isInLine && Math.abs(wheelDelta) > (wHeight / anchor2)) {
                    focusPosition = oTop
                }
                else if (window.scrollY > oTop && window.scrollY < (oTop + wHeight)) {
                    focusPosition = oTop
                }
            })
            if (focusPosition !== null) {
                debug.innerHTML = `${debug.innerHTML}<br>FOCUS! (${focusPosition})`
                debug?.scrollTo({top: 100000000000})
                lockScroll = setTimeout(() => {
                    lockScroll = null
                }, 500)
                window.scrollTo({top: focusPosition, left: 0, behavior: 'smooth'})
            }
        }
    }, 100)

    document.querySelectorAll('.parallax .step').forEach((objStep, idx) => {
        const bounds = objStep.getBoundingClientRect()
        let prevStep = objStep.previousSibling
        if (!objStep.getAttribute('data-originalPosition')) objStep.setAttribute('data-originalPosition', objStep.offsetTop)
        if (prevStep && !prevStep.className?.includes('step')) prevStep = null
        let nextStep = objStep.nextSibling
        if (nextStep && !nextStep.className?.includes('step')) nextStep = null
        const wHeight = window.innerHeight
        let opacity = ((wHeight / 1.5) - bounds.top) / (wHeight / 1.5)
        if (nextStep) {
            const nextBounds = nextStep.getBoundingClientRect()
            if (nextBounds.top >= 0) opacity -= ((wHeight - nextBounds.top) / wHeight)
        }
        else if (bounds.top < -(wHeight / 10)) {
            clearTimeout(autoFocus)
        }
        opacity = Math.round(opacity * 100) / 100
        if (opacity > 1) opacity = 1
        if (bounds.top < 0 && nextStep) opacity = 0
        if (bounds.top <= 100) objStep.classList.add('active')
        else objStep.classList.remove('active')
        objStep.style.opacity = opacity
    })

}

const attachEvents = function(){
    window.addEventListener('scroll', manageScroll)
}

const dettachEvents = function(){
    window.removeEventListener('scroll', manageScroll)
}

onMounted(attachEvents)
onBeforeUnmount(dettachEvents)

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DefaultFooter = _resolveComponent("DefaultFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(HomeHeader),
      _hoisted_4,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "block title animation ctoaas",
          onMousemove: _withModifiers(moveCard, ["prevent"]),
          onMouseout: _withModifiers(outCard, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: `https://images.unsplash.com/photo-1572177812156-58036aae439c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=${imgSize.value}&q=30`,
              alt: "Le mot Projects en 3D sur un mur en béton"
            }, null, 8, _hoisted_8)
          ]),
          _hoisted_9
        ], 32),
        _hoisted_10
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: "block title animation develop",
          onMousemove: _withModifiers(moveCard, ["prevent"]),
          onMouseout: _withModifiers(outCard, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: `https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=${imgSize.value}&q=30`,
              alt: "Un ordinateur avec du code JavaScript"
            }, null, 8, _hoisted_15)
          ]),
          _hoisted_16
        ], 32),
        _hoisted_17,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fad', 'bullseye-pointer'] }),
                      _createTextVNode(" Vos Objectifs ")
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fad', 'traffic-light-slow'] }),
                      _createTextVNode(" Vos Contraintes ")
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fad', 'people-arrows'] }),
                      _createTextVNode(" Un(e) coordinateur(rice) de projet ")
                    ])
                  ])
                ]),
                _hoisted_32
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "overlay",
                  style: _normalizeStyle(`background-image:url('https://images.unsplash.com/photo-1501139083538-0139583c060f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=${imgSize.value}&q=30');`)
                }, null, 4),
                _hoisted_35,
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fad', 'book-bookmark'] }),
                      _createTextVNode(" Le Cahier des Charges ")
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fad', 'telescope'] }),
                      _createTextVNode(" Une Stratégie ")
                    ])
                  ])
                ]),
                _hoisted_42
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _hoisted_46,
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fal', 'thought-bubble'] }),
                      _createTextVNode(" De l'imagination ")
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'figma'] }),
                      _createTextVNode(" Figma ")
                    ])
                  ])
                ]),
                _hoisted_53
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _hoisted_57,
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'vuejs'] }),
                      _createTextVNode(" VueJS ")
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'python'] }),
                      _createTextVNode(" Python ")
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'sass'] }),
                      _createTextVNode(" SASS (CSS) ")
                    ])
                  ])
                ]),
                _hoisted_65
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _hoisted_69,
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'github'] }),
                      _createTextVNode(" GitHub ")
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fab', 'docker'] }),
                      _createTextVNode(" Docker ")
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'clouds'] }),
                      _createTextVNode(" Clouder (GCP, AWS, …) ")
                    ])
                  ])
                ]),
                _hoisted_77
              ])
            ])
          ])
        ])
      ]),
      _hoisted_78,
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", {
          class: "block title animation hosting",
          onMousemove: _withModifiers(moveCard, ["prevent"]),
          onMouseout: _withModifiers(outCard, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("img", {
              src: `https://images.unsplash.com/photo-1526666923127-b2970f64b422?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=${imgSize.value}&q=30`,
              alt: "Une antenne parabolique tournée vers le ciel, dans un désert"
            }, null, 8, _hoisted_81)
          ]),
          _hoisted_82
        ], 32),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_component_font_awesome_icon, { icon: ['fad', 'tricycle'] }),
                _createTextVNode(" Starter ")
              ]),
              _hoisted_87
            ]),
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                _createVNode(_component_font_awesome_icon, { icon: ['fad', 'shuttle-space'] }),
                _createTextVNode(" WildSys Cloud ")
              ]),
              _hoisted_93
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("div", _hoisted_97, [
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_103,
                _hoisted_104
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_107,
                _hoisted_108
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_111,
                _hoisted_112
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_115,
                _hoisted_116
              ])
            ]),
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", _hoisted_119, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_120,
                _hoisted_121
              ]),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("div", _hoisted_123, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fad', 'square-question'] })
                ]),
                _hoisted_124,
                _hoisted_125
              ])
            ])
          ])
        ])
      ]),
      _hoisted_126
    ]),
    _createVNode(_component_DefaultFooter)
  ], 64))
}
}

})